<template>
  <div v-if="project" class="import-page">
    <div class="layout__content__header layout__content__header--white">
      <AppBack :text="'zpet'" :route="{ name: 'lora' }" />
      <h1 class="text-center mb-2 mb-md-3">
        {{ $t("hromadnyImport") }}
      </h1>
    </div>
    <div v-if="project.projectId" class="layout__content__content layout__content__content--white">
      <div class="import-form__steps d-flex align-items-center justify-content-center">
        <div class="import-form__steps__wrapper">
          <div :class="{ active: page.indexOf(1) > -1 }" class="import-form__steps__item d-flex align-items-center">
            <div
              class="import-form__steps__number d-flex align-items-center justify-content-center font-weight-bold text-white"
            >
              1
            </div>
            <span class="font-weight-light">{{ $t("import") }}</span>
          </div>
        </div>
        <div class="import-form__steps__wrapper">
          <div :class="{ active: page.indexOf(2) > -1 }" class="import-form__steps__item d-flex align-items-center">
            <div
              class="import-form__steps__number d-flex align-items-center justify-content-center font-weight-bold text-white"
            >
              2
            </div>
            <span class="font-weight-light">{{ $t("dokonceni") }}</span>
          </div>
        </div>
      </div>
      <div v-if="page.indexOf(2) == -1">
        <div v-if="!importError">
          <div
            class="import-form__wrapper import-form__wrapper--large d-flex align-items-center justify-content-between mt-4 mb-4 mx-auto flex"
          >
            <div class="w-100">
              <div
                class="w-100 text-center text-larger font-weight-light mt-2 mb-5"
                v-html="this.$t('bulkImportFirstStepHelp')"
              />
              <div class="flex items-center justify-center w-100 h-screen text-center">
                <div class="import-form__file" @dragleave="dragleave" @dragover="dragover" @drop="drop">
                  <input
                    id="assetsFieldHandle"
                    ref="file"
                    accept=".xlsx,.csv"
                    class="w-px h-px opacity-0 overflow-hidden position-absolute invisible"
                    name="fields[assetsFieldHandle][]"
                    type="file"
                    @change="onChange"
                  />
                  <label v-if="!file" class="block cursor-pointer" for="assetsFieldHandle">
                    <div class="d-flex flex-wrap">
                      <div class="w-100 d-">
                        <img src="@/assets/icons/bulk-import.svg" />
                      </div>
                      <div class="w-100 d-flex flex-wrap justify-content-center">
                        <div class="btn btn-primary">
                          {{ $t("nahratSoubor") }}
                        </div>
                        <div class="w-100 text-center">
                          <p class="mt-3 font-weight-light mb-0">
                            {{ $t("neboSemSouborPretahnete") }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </label>
                  <p v-if="showErrorType" class="text-danger">
                    {{ $t("spatnyTypSouboru") }}
                  </p>
                  <div v-cloak v-if="file" class="mt-4 d-flex align-items-center import-form__file__selected">
                    <div class="mb-2">
                      <img
                        v-if="file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'"
                        src="@/assets/icons/xls.svg"
                      />
                      <img v-else src="@/assets/icons/csv.svg" />
                    </div>
                    <div class="d-flex justify-content-between text-left col-10">
                      <div class="ml-2 col-12">
                        <strong>{{ file.name }}</strong>
                        <div class="atom-uploader">
                          <div class="atom-uploader__wrapper">
                            <div
                              :class="{ danger: errorsToTranslate.length > 0 }"
                              :style="{
                                width: (uploading > 100 ? 100 : uploading) + '%'
                              }"
                              class="atom-uploader__loader"
                            />
                          </div>
                        </div>
                        <div class="small">
                          {{ progressMessage }}
                        </div>
                        <div v-if="this.progressDevicesProcessed.totalDevices" class="small">
                          <div class="small">
                            {{ $t("BULKIMPORT_LABEL_ALLDEVICES") }} / {{ $t("BULKIMPORT_LABEL_COMPLETEDEVICES") }} /
                            {{ $t("BULKIMPORT_LABEL_ERRORDEVICES") }}
                          </div>
                          <div class="small">
                            {{ progressDevicesProcessed.totalDevices }} /
                            <span class="text-success">
                              {{ progressDevicesProcessed.complete }}
                            </span>
                            /
                            <span class="text-danger">
                              {{ progressDevicesProcessed.error }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="pointer ml-3" @click="removeFile()">
                        <img src="@/assets/icons/actions/ico-ico-delete-red.svg" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="import-form__wrapper justify-content-center mt-3 mx-auto">
            <div v-if="isError" class="text-danger">
              {{ $t("VyplnteVsechnaPovinnaPole") }}
            </div>
          </div>
          <div v-if="file.name">
            <div class="import-form__wrapper justify-content-center mt-3 mx-auto">
              <div class="font-weight-light text-left mb-1">
                {{ $t("zpusobAktivace") }}
              </div>
              <div class="custom-control__select w-100">
                <div
                  :class="{ opened: devicetypeOpened }"
                  class="custom-control__select__selected"
                  @click="devicetypeOpened = devicetypeOpened ? false : true"
                >
                  {{ devicetype }} -
                  <span v-if="devicetype === 'ABP'">{{ $t("ABPdesc") }}</span>
                  <span v-else-if="devicetype === 'OTAA'">
                    {{ $t("OTAAdesc") }}
                  </span>
                </div>
                <div :class="{ opened: devicetypeOpened }" class="custom-control__select__options">
                  <div
                    class="custom-control__select__option d-flex align-items-center"
                    @click="
                      () => {
                        devicetype = 'ABP'
                        devicetypeOpened = false
                      }
                    "
                  >
                    <div class="check">
                      <img v-if="devicetype == 'ABP'" class="" src="@/assets/icons/check.svg" />
                    </div>
                    <span class="font-weight-light">ABP - {{ $t("ABPdesc") }}</span>
                  </div>
                  <div
                    class="custom-control__select__option d-flex align-items-center"
                    @click="
                      () => {
                        devicetype = 'OTAA'
                        devicetypeOpened = false
                      }
                    "
                  >
                    <div class="check">
                      <img v-if="devicetype == 'OTAA'" class="" src="@/assets/icons/check.svg" />
                    </div>
                    <span class="font-weight-light">OTAA - {{ $t("OTAAdesc") }}</span>
                  </div>
                </div>
              </div>
            </div>
            <FormSelect
              :has-error="isError && !selectedDataFlow.deviceGroupId"
              :items="loraDataFlowList"
              :label="$t('DATA_FLOW')"
              :value="selectedDataFlow"
              class="import-form__wrapper mx-auto mt-3"
              item-text="deviceGroupName"
              item-value="deviceGroupId"
              @change="selectedDataFlow = $event"
            />

            <!--            <FormSelect-->
            <!--              class="import-form__wrapper mx-auto mt-3"-->
            <!--              item-text="profileName"-->
            <!--              item-value="profileId"-->
            <!--              item-subtext="subText"-->
            <!--              subtext-font-size="12px"-->
            <!--              :items="-->
            <!--                importProfileList.map((profile) => ({-->
            <!--                  ...profile,-->
            <!--                  subText: `${$t('Minimální ADR datarate')}: ${profile.adrMin ?? 0}\n${$t(-->
            <!--                    'Maximální ADR datarate'-->
            <!--                  )}: ${profile.adrMax ?? 0}`-->
            <!--                }))-->
            <!--              "-->
            <!--              :label="$t('IMPORT_PROFILE')"-->
            <!--              :value="selectedImportProfile"-->
            <!--              @change="selectedImportProfile = $event"-->
            <!--            />-->

            <div class="import-form__wrapper justify-content-center mt-3 mx-auto">
              <FormSelect
                :items="services"
                :label="$t('prirazeniKeSluzbe')"
                :value="selectedService"
                item-subtext="custServiceId"
                item-text="tarifName"
                item-value="custServiceId"
                @change="
                  (e) => {
                    selectedService = e
                    loadService(e.custServiceId)
                  }
                "
              />
              <div class="custom-control__select disabled-with-result mt-1">
                <ServiceLimits v-if="loadedService" :service="selectedService" />
              </div>
            </div>
            <FormSelect
              :info-text="'info_bulkimport_spustitZarizeniDoRezimu'"
              :info-tooltip="'tooltip_bulkimport_spustitZarizeniDoRezimu'"
              :items="stateOptions"
              :label="$t('spustitZarizeniDoRezimu')"
              :value="stateOptions.find((op) => op.value === selectedState)"
              class="mb-3 mx-auto import-form__wrapper mt-3"
              item-text="text"
              item-value="value"
              @change="selectedState = $event.value"
            />

            <div>
              <div v-if="fileType == 'csv'" class="import-form__wrapper justify-content-center mt-3 mx-auto">
                <div class="font-weight-light text-left mb-1">
                  {{ $t("separator") }}
                </div>
                <div class="custom-control__select w-100">
                  <div
                    :class="{ opened: separatorOpened }"
                    class="custom-control__select__selected"
                    @click="separatorOpened = separatorOpened ? false : true"
                  >
                    {{ separator }}
                  </div>
                  <div :class="{ opened: separatorOpened }" class="custom-control__select__options">
                    <div
                      class="custom-control__select__option d-flex align-items-center"
                      @click="
                        separator = ';'
                        separatorOpened = false
                      "
                    >
                      <div class="check">
                        <img v-if="separator == ';'" class="" src="@/assets/icons/check.svg" />
                      </div>
                      <span class="font-weight-light">;</span>
                    </div>
                    <div
                      class="custom-control__select__option d-flex align-items-center"
                      @click="
                        () => {
                          separator = ','
                          separatorOpened = false
                        }
                      "
                    >
                      <div class="check">
                        <img v-if="separator == ','" class="" src="@/assets/icons/check.svg" />
                      </div>
                      <span class="font-weight-light">,</span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="fileType == 'csv'" class="import-form__wrapper justify-content-center mt-3 mx-auto">
                <div class="font-weight-light text-left mb-1">
                  {{ $t("encoding") }}
                </div>
                <div class="custom-control__select w-100">
                  <div
                    :class="{ opened: encodingOpened }"
                    class="custom-control__select__selected"
                    @click="encodingOpened = encodingOpened ? false : true"
                  >
                    {{ encoding }}
                  </div>
                  <div :class="{ opened: encodingOpened }" class="custom-control__select__options">
                    <div
                      class="custom-control__select__option d-flex align-items-center"
                      @click="
                        () => {
                          encoding = 'utf-8'
                          encodingOpened = false
                        }
                      "
                    >
                      <div class="check">
                        <img v-if="encoding == 'utf-8'" class="" src="@/assets/icons/check.svg" />
                      </div>
                      <span class="font-weight-light">utf-8</span>
                    </div>
                    <div
                      class="custom-control__select__option d-flex align-items-center"
                      @click="
                        () => {
                          encoding = 'windows-1250'
                          encodingOpened = false
                        }
                      "
                    >
                      <div class="check">
                        <img v-if="encoding == 'windows-1250'" class="" src="@/assets/icons/check.svg" />
                      </div>
                      <span class="font-weight-light">windows-1250</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="import-form__wrapper d-flex justify-content-end mt-4 mx-auto">
              <div class="btn btn-primary" @click="checkInputs()">
                {{ $t("importovatZarizeni") }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="this.importErrors.length > 0" class="mt-4">
        <div class="import-form__wrapper--large justify-content-center mt-3 mx-auto">
          <div class="py-4" />
          <div class="radio radio--help radio--help--danger d-flex align-items-center justify-content-center opened">
            <div class="radio--help__slide radio--help__slide--import d-flex">
              <img src="@/assets/icons/radio/img-pan-radio-confused.svg" />
              <div class="radio--help__contents-wrapper w-100 d-flex">
                <div class="radio--help__content w-100 text-center active">
                  <div class="w-100">
                    <p class="font-weight-bold radio--help__title" />
                    <div class="font-weight-light radio--help__text mb-3">
                      V nahrávaném souboru
                      <span>
                        <span>{{ this.file.name }}</span>
                      </span>
                      <br />
                      jsme našli
                      <span class="font-weight-bolder">
                        {{ this.importErrors.length }}
                        {{
                          $filters.inflection(
                            this.importErrors.length,
                            $t("BULKIMPORT_ERROR_1_CHYBU"),
                            $t("BULKIMPORT_ERROR_2_4_CHYBY"),
                            $t("BULKIMPORT_ERROR_5_CHYB")
                          )
                        }}
                      </span>
                      <span v-if="page.indexOf(2) > -1">
                        {{ $t("BULK_IMPORT_ERRORINFO_Z_CELKOVEHO_POCTU") }}
                        {{ this.importErrors.length + deviceIds.length }}
                        {{ $t("BULK_IMPORT_ERRORINFO_ZARIZENI") }}
                      </span>
                      .
                    </div>
                    <div class="d-flex align-items-center justify-content-center">
                      <div class="btn btn-primary d-flex align-items-center justify-content-center">
                        <div class="atom-icon">
                          <img src="@/assets/icons/ico-ico-btn-upload.svg" />
                        </div>
                        <span
                          @click="
                            () => {
                              importError = 0
                              importErrors = []
                              page = [1]
                              removeFile()
                            }
                          "
                        >
                          {{ $t("nahratNovySoubor") }}
                        </span>
                      </div>
                    </div>
                    <p class="link mt-3" @click="exportErrorMessages('xlsx')">
                      {{ $t("vyexportovatSouborSChybami") }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="page.indexOf(2) > -1">
        <div class="import-form__wrapper--xlarge import-form__wrapper--xlarge justify-content-center mt-3 mx-auto">
          <div class="py-4" />
          <div class="radio radio--help radio--help--success d-flex align-items-center justify-content-center opened">
            <div class="radio--help__slide radio--help__slide--import2step d-flex flex-column flex-md-row">
              <img class="mx-auto mb-3 mb-md-0" src="@/assets/icons/radio/img-pan-radio-points.svg" />
              <div class="radio--help__contents-wrapper w-100 d-flex">
                <div class="radio--help__content w-100 text-center active">
                  <div class="w-100">
                    <div class="font-weight-light radio--help__text mb-3">
                      {{ $t("naimportovaliJsme") }} {{ deviceIds.length }}
                      <span v-if="deviceIds.length == 1">
                        {{ $t("noveZarizeni1") }}
                      </span>
                      <span v-if="deviceIds.length > 1 && deviceIds.length < 5">
                        {{ $t("noveZarizeni") }}
                      </span>
                      <span v-if="deviceIds.length >= 5">
                        {{ $t("novychZarizeni") }}
                      </span>
                      .
                    </div>
                    <div class="d-flex align-items-center justify-content-center flex-column flex-sm-row">
                      <div
                        class="btn btn-primary d-flex align-items-center justify-content-center"
                        @click="showImportedDevices"
                      >
                        <div class="atom-icon">
                          <img src="@/assets/icons/ico-ico-stejne-endpointy.svg" />
                        </div>
                        <div class="py-3">
                          {{ $t("SHOW_IMPORTED_DEVICES") }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="layout__content__content layout__content__content--white">
      <p class="text-center">
        {{ $t("neniVybranProjekt") }}
      </p>
    </div>
    <div v-if="errorsToTranslate.length > 0">
      <ErrorModal :opened="openedError" :centered="true" :errors="errorsToTranslate" @close="openedError = false" />
    </div>
  </div>
</template>

<script>
import axios from "axios"
import AppBack from "@/components/back.vue"
import ErrorModal from "@/components/confirmations/error.vue"
import ServiceLimits from "@/components/boxes/serviceLimits.vue"
import FormSelect from "@/components/forms/FormSelect.vue"
import { client } from "@/main"
import { useAuthStore } from "@/store/modules/auth"
import { useProjectStore } from "@/store/modules/project"
import { useConfigStore } from "@/store/modules/config"
import { useGroupsStore } from "@/store/modules/groups"
import { useEndpointsStore } from "@/store/modules/endpoints"

export default {
  components: {
    ServiceLimits,
    AppBack,
    ErrorModal,
    FormSelect,
  },
  setup() {
    const authStore = useAuthStore()
    const projectStore = useProjectStore()
    const configStore = useConfigStore()
    const groupsStore = useGroupsStore()

    const endpointsStore = useEndpointsStore()

    return { authStore, projectStore, configStore, groupsStore, endpointsStore }
  },
  data() {
    return {
      progressMessage: "",
      progressDevicesProcessed: [],
      showIntervalValidationExportLink: false,
      showAPIValidationExportLink: false,
      importErrors: [],
      importError: false,
      uniqueid: "",
      file: "",
      page: [1],
      selectedService: {},
      selectedDataFlow: {},
      selectedImportProfile: null,
      importProfileList: [],
      showHelp: false,
      loadedService: false,
      stateOpened: false,
      selectedState: "A",
      preregistrationAllowed: false,
      isError: false,
      helpSlidesImport: [],
      errorsToTranslate: [],
      openedError: false,
      interval: 0,
      devicetype: "ABP",
      devicetypeOpened: false,
      separator: ";",
      separatorOpened: false,
      encoding: "utf-8",
      encodingOpened: false,
      path: process.env.VUE_APP_CMS,
      openedEditGroup: [],
      deviceIds: [],
      uploading: 0,
      showErrorType: false
    }
  },
  computed: {
    loraDataFlowList() {
      return this.groupsStore.loraDataFlowList
    },
    services() {
      return this.$store.getters["services/services"].filter((s) => !s.suspended && !s.discontinued)
    },
    project() {
      return this.projectStore.selectedProject
    },
    locale() {
      return this.$i18n.locale
    },
    radioDisabled() {
      return this.configStore.isRadioHelpDisabled
    },
    user() {
      return this.authStore.user
    },
    fileType() {
      return this.file.name.split(".").pop()
    },
    stateOptions() {
      return [
        {
          atomCircleClass: "atom-circle--success",
          text: this.$t("active"),
          value: "A",
          statusText: "active"
        },
        ...(this.preregistrationAllowed
          ? [
              {
                atomCircleClass: "atom-circle--gray",
                text: this.$t("PREDREGISTRACE"),
                value: "P",
                statusText: "preregistration"
              }
            ]
          : [])
      ]
    }
  },
  watch: {
    project() {
      this.selectedService = {}
      this.loadedService = false
      this.selectedDataFlow = {}
      this.getDataFlowList()
      this.endpointsStore.getAllEndpoints({
        sort: "custDestId",
        rowsPerPage: 1000,
        currentPage: 0
      })
    },
    radioDisabled() {
      this.showHelp = !this.radioDisabled
    },
    page() {
      this.importError = false
    }
  },
  mounted() {
    this.showHelp = !this.radioDisabled

    if (this.project) {
      this.getDataFlowList()
      this.getImportProfileList()
      this.endpointsStore.getAllEndpoints({
        sort: "custDestId",
        rowsPerPage: 1000,
        currentPage: 0
      })
    }
    this.uploading = 0
  },
  methods: {
    getDataFlowList() {
      return this.groupsStore.getGroups()
    },
    async getImportProfileList() {
      const { data } = await client.path("/lora/devices/profiles").method("get").create()()
      this.importProfileList = data.data
    },
    onChange() {
      console.log(this.$refs.file.files[0])
      if (
        this.$refs.file.files[0].name.split(".").pop() === "xlsx" ||
        this.$refs.file.files[0].name.split(".").pop() === "xlx" ||
        this.$refs.file.files[0].name.split(".").pop() === "csv"
      ) {
        this.showErrorType = false
        this.file = this.$refs.file.files[0]
        this.uploading = 0
      } else {
        this.showErrorType = true
      }
    },
    removeFile() {
      if (this.$refs.file) this.$refs.file.value = null
      this.file = ""
      if (this.$refs.file && this.$refs.file.value) {
        this.$refs.file.type = "text"
        this.$refs.file.type = "file"
      }
      this.progressMessage = ""
      this.progressDevicesProcessed = []
      this.uploading = 0
    },
    dragover(event) {
      event.preventDefault()
      if (!event.currentTarget.classList.contains("bg-green-300")) {
        event.currentTarget.classList.remove("bg-gray-100")
        event.currentTarget.classList.add("bg-green-300")
      }
    },
    dragleave(event) {
      event.currentTarget.classList.add("bg-gray-100")
      event.currentTarget.classList.remove("bg-green-300")
    },
    drop(event) {
      event.preventDefault()
      this.$refs.file.files = event.dataTransfer.files
      this.onChange()
      event.currentTarget.classList.add("bg-gray-100")
      event.currentTarget.classList.remove("bg-green-300")
    },
    loadService(serviceId) {
      this.loadedService = false
      axios
        .get(process.env.VUE_APP_API + "/services/" + serviceId, {})
        .then((result) => {
          this.service = result.data.data
          this.selectedService = result.data.data
          this.loadedService = true
          this.setPreregistrationAllowed()
        })
        .catch(() => {})
    },
    checkInputs() {
      this.uploading = 0
      this.isError = false
      if (!this.selectedService.custServiceId || !this.selectedDataFlow) {
        this.isError = true
      } else {
        this.importDevice()
      }
    },
    importDevice() {
      this.errorsToTranslate = []
      const dataToImport = new FormData()
      dataToImport.append("file", this.file, this.file.name)
      this.errorsToTranslate = []
      let requestString = ""

      let DEV_LMT_ACTUAL = this.service.parameters.filter((e) => e.name == "COUNTER-DEV_LMT_ACTUAL")

      /** if DEV_LMT_ACTUAL[0].value == 0 there is no limit */
      let unlimited = DEV_LMT_ACTUAL[0].value == 0 ? 1 : 0

      if (this.fileType === "csv") {
        requestString =
          "/processImportFile?format=" +
          this.fileType +
          "&devicetype=" +
          this.devicetype +
          "&custServiceId=" +
          this.selectedService.custServiceId +
          "&projectId=" +
          this.project.projectId +
          "&encoding=" +
          this.encoding +
          "&separator=" +
          this.separator +
          "&unlimited=" +
          unlimited +
          "&preregistration=" +
          (this.selectedState == "P" ? true : false) +
          "&devicesLimit=" +
          (DEV_LMT_ACTUAL[0].value - this.service.devices.count)
      } else {
        requestString =
          "/processImportFile?format=" +
          this.fileType +
          "&devicetype=" +
          this.devicetype +
          "&custServiceId=" +
          this.selectedService.custServiceId +
          "&projectId=" +
          this.project.projectId +
          "&unlimited=" +
          unlimited +
          "&preregistration=" +
          (this.selectedState == "P" ? true : false) +
          "&devicesLimit=" +
          (DEV_LMT_ACTUAL[0].value - this.service.devices.count)
      }
      this.uploading = 5
      this.progressMessage = this.$t("BULKIMPORT_UPLOADING")
      this.importErrors = []
      this.importError = false
      this.uniqueid = ""
      axios
        .post(process.env.VUE_APP_APICMS + requestString, dataToImport, {
          headers: {
            "Content-Type": `multipart/form-data; boundary=${dataToImport._boundary}`
          }
        })
        .then((result) => {
          this.progressMessage = this.$t("BULKIMPORT_UPLOADED")
          this.createdDevice = dataToImport
          if (Array.isArray(result.data.error) && result.data.error.length) {
            result.data.error.forEach((error) => {
              error.messages.forEach((message) => {
                //this.errorsToTranslate.push(message);
                this.importErrors.push(message)
              })
            })

            this.stopInterval(this.interval)
            this.importError = true
            this.uploading = 100
            this.showIntervalValidationExportLink = true
            this.uniqueid = result.data.uniqueid
          } else {
            if (result.data.error.messages !== undefined) {
              result.data.error.messages.forEach((message) => {
                this.errorsToTranslate.push(message)
              })
              this.openedError = true
              this.uploading = 100
              console.log("bulkimport internal error 1")
            } else {
              console.log("bulkimport internal error 2")
              if (result.data.uniqueid != null) {
                this.stopInterval(this.interval)
                this.uploading = 20
                this.checkImport(result.data.uniqueid)
              }
            }
          }
        })
        .catch((error) => {
          if (error.data) this.errorsToTranslate.push(this.$t("BulkImportImportDeviceError"))

          console.log("bulkimport internal error 3")
          this.openedError = true
          this.stopInterval(this.interval)
        })

      this.interval = setInterval(() => {
        this.uploading += 1
      }, 2000)
    },
    checkImport(uniqueId) {
      let promises = []
      let importDone = false
      promises.push(
        axios
          .post(process.env.VUE_APP_APICMS + "/checkImport?uniqueid=" + uniqueId , {
            token: this.user.access_token})
          .then((result) => {
            if (result.data.summary.progressMessage !== null) {
              console.log("processmessage:" + result.data.summary.progressMessage)
              console.log("processmessage:")
              console.log(result.data.summary)

              this.progressMessage = result.data.summary.progressMessage
              this.uploading = 20 + result.data.summary.progressBar
              if (this.uploading > 100) this.uploading = 100
            }
            if (result.data.summary.totalDevices) {
              this.progressDevicesProcessed.totalDevices = result.data.summary.totalDevices
              this.progressDevicesProcessed.complete = result.data.summary.complete
              this.progressDevicesProcessed.error = result.data.summary.error
            }
            if (result.data.summary.inProgress === 0) {
              if (result.data.summary.error > 0) {
                this.errorsToTranslate = []
                console.log("bulkimport error found")
                this.errorsToTranslate.push("BULK_IMPORT_IOTBE_API_ERROR")
                result.data.summary.errorMessages.forEach((message) => {
                  this.importErrors.push(message)
                  console.log(message)
                })
                this.openedError = true
                this.uploading = 100
                importDone = true
                this.uniqueid = uniqueId

                this.stopInterval(this.interval)
                this.importError = true
                this.uploading = 100
                this.showIntervalValidationExportLink = true
              }
              if (result.data.summary.complete > 0) {
                result.data.summary.successDevices.forEach((device) => {
                  this.deviceIds.push(device)
                })
                this.assignImportedDevicesToGroup()
                this.page.push(2)
                this.$store.dispatch("services/getServices")
                importDone = true
              }
            }
          })
          .catch(() => {})
      )

      return Promise.all(promises).then(() => {
        if (!importDone) {
          this.checkImport(uniqueId)
        }
      })
    },
    stopInterval() {
      clearInterval(this.interval)
    },
    /**
     * check whether prergistration is allowed aftre service select
     * preregistration is allowed when COUNTER-PREREGISTRATION_MSGS > 0 or COUNTER-PREREGISTRATION_DAYS > 0
     */
    setPreregistrationAllowed() {
      this.preregistrationAllowed = false
      this.selectedState = "A"

      let PREREGISTRATION_MSGS = this.service.parameters.filter(
        (p) => p.name == "COUNTER-PREREGISTRATION_MSGS" && p.value > 0
      )
      let PREREGISTRATION_DAYS = this.service.parameters.filter(
        (p) => p.name == "COUNTER-PREREGISTRATION_DAYS" && p.value > 0
      )

      if (PREREGISTRATION_MSGS.length > 0) {
        this.preregistrationAllowed = true
      }

      if (PREREGISTRATION_DAYS.length > 0) {
        this.preregistrationAllowed = true
      }
    },
    exportErrorMessages(type) {
      this.$store.commit("modals/setWaitingLoader", this.$t("Exportuji data, čekejte prosím..."))

      axios
        .get(process.env.VUE_APP_APICMS + "/exportErrorDevices?uniqueid=" + this.uniqueid, {
          responseType: "blob"
        })
        .then((response) => {
          if (response.data != undefined) {
            var fileName, blob

            if (type == "csv") {
              fileName = "importErrorsExport.csv"
              blob = new Blob([response.data], {
                type: "text/csv;charset=utf-8;"
              })
            } else if (type == "xlsx") {
              fileName = "importErrorsExport.xlsx"
              blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              })
            }

            if (window.navigator.msSaveBlob) {
              // FOR IE BROWSER
              navigator.msSaveBlob(blob, fileName)
            } else {
              // FOR OTHER BROWSERS
              var csvUrl = URL.createObjectURL(blob)
              const link = document.createElement("a")
              link.setAttribute("href", csvUrl)
              link.setAttribute("download", fileName)
              link.click()
              this.$store.commit("modals/setWaitingLoader", "")
            }
          }
        })
        .catch(() => {
          this.$store.commit("modals/setWaitingLoader", "")
        })
    },
    async assignImportedDevicesToGroup() {
      for (const deviceId of this.deviceIds) {
        try {
          await axios.post(
            `${process.env.VUE_APP_API}/device-groups/${this.selectedDataFlow.deviceGroupId}/devices/lora/${deviceId}/assign`
          )
        } catch (error) {
          this.errorsToTranslate.push(error.data)
        }
      }
      if (this.errorsToTranslate.length !== 0) {
        this.openedError = true
      }
    },
    showImportedDevices() {
      this.$router.push({ name: "lora" })
    }
  }
}
</script>

<style scoped></style>
